module.exports = __webpack_public_path__ + "static/cartepostale-DEI-viole-1200-33c9cf3f0ecea07f23934b4221b8ddf8.png";